import { useFormikContext } from 'formik'

import { AttachServiceRequestsModal } from '../../../../Request'
import { NEWSBOARD_POST_FORM_FIELD_REQUESTS } from '../../NewsboardPostForm.constants'

export function useAttachServiceRequests({ setModal, onCloseModal }) {
  const { setFieldValue, values } = useFormikContext()

  function handleAttachRequest(value) {
    setFieldValue(NEWSBOARD_POST_FORM_FIELD_REQUESTS, value).then(() => {
      onCloseModal()
    })
  }

  function handleOpenAttachServiceRequest() {
    setModal(
      <AttachServiceRequestsModal
        multipleSelection
        headerProps={{
          text: 'Modal.AttachRequestsToPostTitleKey',
        }}
        initialSelection={values[NEWSBOARD_POST_FORM_FIELD_REQUESTS]}
        restoreAttention={false}
        onClose={onCloseModal}
        onSelectedAttachRequests={handleAttachRequest}
      />
    )
  }

  function handleRemoveAttachedRequest(id) {
    setFieldValue(
      NEWSBOARD_POST_FORM_FIELD_REQUESTS,
      values[NEWSBOARD_POST_FORM_FIELD_REQUESTS].filter(item => item.id !== id)
    )
  }

  return { handleOpenAttachServiceRequest, handleRemoveAttachedRequest }
}
